<template>
  <div>
    <!-- 选项框 -->
    <div class="home screenbox p5">
      <div id="searchBar" :class="searchBarFixed == true ? 'searchBar' : ''" class="screen clearfix">
        <div class="w10 fr">
          <div class="wrap">
            <el-select v-model="yearsvalue" @change="yearsInput" filterable size="medium">
              <el-option v-for="item in years" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <div class="icons fl">
          <ul class="clearfix">
            <li v-for="(item, index) in newDataList" :key="index">
              <!-- 有子菜单的项（三支柱）才渲染 el-dropdown -->
              <el-dropdown
                v-if="item.children && item.children.length > 0 && item.IndicatorId == 44"
                trigger="hover" placement="bottom-start" :popper-class="'dropdown-menu-' + index"
                @command="handleChildClick">
                <a @click="handleIconClick(index, item)" class="w7-09" :class="`icon${index + 1}`"
                  :title="item.Name || '总体'">
                  <span>{{ item.Name }}</span>
                </a>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :class="(pageStateMain && child.IndicatorId == indicatorid) ? 'Z-active' : ''"
                    v-for="(child, childIndex) in item.children" :key="childIndex"
                    :command="{ child, parentIndex: index, parentItem: item }">
                    {{ child.Name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- 没有子菜单的项，普通 a 标签 -->
              <a v-else @click="handleIconClick(index, item)" class="w7-09" :class="`icon${index + 1}`"
                :title="item.Name || '总体'">
                <span>{{ item.Name }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="!pageStateMain">
      <!-- 地图 -->
      <div class="mapbox">
        <div class="bj_white2 home">
          <div :style="{ height: '592px', width: '100%' }" ref="myEchart" id="myEchart"></div>
        </div>
      </div>
      <!-- 图表 -->
      <div class="home p5 clearfix">
        <div class="w50 fl">
          <div class="bj_white2">
            <div class="card_title">
              <h1>"{{ barindicatorname }}"得分排名前十的经济体</h1>
            </div>
            <div class="full_box">
              <el-button class="replay" round>replay</el-button>
            </div>
            <div ref="chart1div" id="chart1div" style="width:100%">
              <PillarChart v-if="chartData1.length > 0" :chartData="chartData1" :dataIndex="0" labelMode="ratio"
                :interval="2000" :autoplay="true" height="400" :showFlag="true" :flagPathMapper="getFlagPath"
                :showPercentSign="false" />
              <img v-show="chart1_img" src="../../../assets/imgs/cgitchartdefault.jpg"
                style="margin:0 auto; height:400px;width: 100%;" />
            </div>
          </div>
        </div>
        <div class="w50 fl">
          <div class="bj_white2">
            <div class="card_title">
              <h1>{{ (selectyear && selectyear.slice ? selectyear.slice(0,4) : selectyear)+'年' }}"{{ barindicatorname }}"得分排名后十位的经济体</h1>
            </div>
            <PillarChart v-if="chartData2.length > 0" :chartData="chartData2" labelMode="ratio" height="400"
              :showFlag="true" :flagPathMapper="getFlagPath" :showPercentSign="false" :decimalPlaces="0" />
            <img v-show="chart2_img" src="../../../assets/imgs/cgitchartdefault.jpg"
              style="margin:0 auto; height:400px;width: 100%;" />
          </div>
        </div>
      </div>
      <div class="home p5 clearfix"
        v-if="chartData3.length > 0 && chartData3[0].data && chartData3[0].data[0] && chartData3[0].data[0].data.length > 0">
        <div class="w50 fl">
          <div class="bj_white2">
            <div class="card_title">
              <h1>{{ (selectyear && selectyear.slice ? selectyear.slice(0,4) : selectyear)+'年' }}"{{ barindicatorname }}"得分上升幅度前{{ numberToChinese(chartData3[0].data[0].data.length)
              }}的经济体</h1>
            </div>
            <PillarChart v-if="chartData3.length > 0" :chartData="chartData3" labelMode="both" height="400"
              :showFlag="true" :flagPathMapper="getFlagPath" />
            <img v-show="chart3_img" src="../../../assets/imgs/cgitchartdefault.jpg"
              style="margin:0 auto; height:400px;width: 100%;" />
            <span style="color: red;position: absolute;right: 16px;bottom: 16px;"
              v-if="chartData3[0].data[0].data.length < 10">注:该项分指标得分上升的经济体仅有{{
                numberToChinese(chartData3[0].data[0].data.length) }}个。</span>
          </div>
        </div>

        <div class="w50 fl"
          v-if="chartData4.length > 0 && chartData4[0].data && chartData4[0].data[0] && chartData4[0].data[0].data.length > 0">
          <div class="bj_white2">
            <div class="card_title">
              <h1>{{ (selectyear && selectyear.slice ? selectyear.slice(0,4) : selectyear)+'年' }}"{{ barindicatorname }}"得分下降幅度前{{ numberToChinese(chartData4[0].data[0].data.length)
              }}的经济体</h1>
            </div>
            <PillarChart v-if="chartData4.length > 0" :chartData="chartData4" labelMode="both" height="400"
              :showFlag="true" :flagPathMapper="getFlagPath" />
            <img v-show="chart4_img" src="../../../assets/imgs/cgitchartdefault.jpg"
              style="margin:0 auto; height:400px;width: 100%;" />
            <span style="color: red;position: absolute;right: 16px;bottom: 16px;"
              v-if="chartData4[0].data[0].data.length < 10">注:该项分指标得分下降的经济体仅有{{
                numberToChinese(chartData4[0].data[0].data.length) }}个。</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="pageStateMain">
      <!-- 地图 -->
      <div class="mapbox">
        <div class="bj_white2 home">
          <div :style="{ height: '592px', width: '100%' }" ref="myEchart" id="myEchart"></div>
        </div>
      </div>

      <!-- 图表 -->
      <div class="home p5 clearfix">
        <div class="w50 fl">
          <div class="bj_white2">
            <div class="card_title">
              <h1>营商环境成熟度得分排名前十的经济体（{{ barindicatorname }}）</h1>
            </div>
            <div class="full_box">
              <el-button class="replay" round @click="chart1replay">replay</el-button>
            </div>
            <div ref="chart1div" id="chart1div" style="width:100%">
              <div v-show="chart1_chart" :style="{ height: '400px', width: '100%' }" ref="chart1" id="chart1"></div>
              <img v-show="chart1_img" src="../../../assets/imgs/cgitchartdefault.jpg"
                style="margin:0 auto; height:400px;width: 100%;" />
            </div>
          </div>
        </div>
        <div class="w50 fl">
          <div class="bj_white2">
            <div class="card_title">
              <h1>{{ (selectyear && selectyear.slice ? selectyear.slice(0,4) : selectyear)+'年' }}营商环境成熟度得分排名后十位的经济体（{{ barindicatorname }}）</h1>
            </div>
            <div v-show="chart2_chart" :style="{ height: '400px', width: '100%' }" ref="chart2" id="chart2"></div>
            <img v-show="chart2_img" src="../../../assets/imgs/cgitchartdefault.jpg"
              style="margin:0 auto; height:400px;width: 100%;" />
          </div>
        </div>
      </div>
      <div class="home p5 clearfix">
        <div class="w50 fl" v-if="bardata3 && bardata3.data && bardata3.data.length > 0">
          <div class="bj_white2">
            <div class="card_title">
              <h1>{{ (selectyear && selectyear.slice ? selectyear.slice(0,4) :selectyear)+'年' }}营商环境成熟度得分上升幅度前{{ numberToChinese((bardata3 && bardata3.data ? bardata3.data.length :
                0)) }}的经济体（{{ barindicatorname }}）</h1>
            </div>
            <div v-show="chart3_chart" :style="{ height: '400px', width: '95%' }" ref="chart3" id="chart3"></div>
            <img v-show="chart3_img" src="../../../assets/imgs/cgitchartdefault.jpg"
              style="margin:0 auto; height:400px;width: 100%;" />
            <span style="color: red;position: absolute;right: 16px;bottom: 16px;"
              v-if="bardata3 && bardata3.data && bardata3.data.length < 10">注:该支柱得分上升的经济体仅有{{
                numberToChinese(bardata3.data.length) }}个。</span>
          </div>
        </div>

        <div class="w50 fl" v-if="bardata4 && bardata4.data && bardata4.data.length > 0">
          <div class="bj_white2">
            <div class="card_title">
              <h1>{{ (selectyear && selectyear.slice ? selectyear.slice(0,4) : selectyear)+'年' }}营商环境成熟度得分下降幅度前{{ numberToChinese((bardata4 && bardata4.data ? bardata4.data.length :
                0)) }}的经济体（{{ barindicatorname }}）</h1>
            </div>
            <div v-show="chart4_chart" :style="{ height: '400px', width: '95%' }" ref="chart4" id="chart4"></div>
            <img v-show="chart4_img" src="../../../assets/imgs/cgitchartdefault.jpg"
              style="margin:0 auto; height:400px;width: 100%;" />
            <span style="color: red;position: absolute;right: 16px;bottom: 16px;"
              v-if="bardata4 && bardata4.data && bardata4.data.length < 10">注:该支柱得分下降的经济体仅有{{
                numberToChinese(bardata4.data.length) }}个。</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import cChart from "../cgit_chart.vue";
import { initCharts } from "../../../assets/js/world_dbusiness2.js";
import { barscroll } from "../../../assets/js/barscroll.js";
import { api } from "@/require/api";
import PillarChart from "./components/PillarChart.vue"
export default {
  data() {
    return {
      searchBarFixed: false,
      years: [],
      yearsvalue: "",
      selectyear: "",
      indicatorid: 1,
      indicatorname: "总体",
      min: 0,
      max: 100,
      worldData: [],
      barindicatorname: "",
      barindicatorname2: "",
      tData: [],
      bardata1: [],
      bardata2: [],
      bardata3: [],
      bardata4: [],
      nameMap: {},
      chart1_chart: true,
      chart1_img: false,
      chart2_chart: true,
      chart2_img: false,
      chart3_chart: true,
      chart3_img: false,
      chart4_chart: true,
      chart4_img: false,
      newDataList: [],
      chartData1: [],
      chartData2: [],
      chartData3: [],
      chartData4: [],
      indicatorname2: '',
      pageStateMain: true,
      chartMap: null,
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,
    };
  },
  components: {
    cChart,
    PillarChart
  },
  created() {
    this.loadnameMapdata();
    this.loadselectdata();
    this.getNavData()
  },

  mounted() {
    this.loadselectdata().then(() => {
      this.icon1();
    })
    window.addEventListener("scroll", this.handleScroll, true);
  },
  destroyed: function () {
    window.removeEventListener("scroll", this.handleScroll);
    [this.chartMap, this.chart1, this.chart2, this.chart3, this.chart4].forEach(chart => {
      if (chart) chart.dispose();
    });
  },
  methods: {
    async getNavData() {
      const data = await api.get("/doingBusiness2026Controller/getIndicatorTree")
      if (data.data.list.length > 0) {
        this.newDataList = data.data.list
        if (this.pageStateMain) {
          this.barindicatorname = this.newDataList[0].children[0].Name
        }
      }
    },
    handleChildClick({ child, parentIndex, parentItem }) {
      this.indicatorid = child.IndicatorId
      this.barindicatorname = child.Name
      this.pageStateMain = true
      this.bardata3 = [];
      this.bardata4 = [];
      this.chartData3 = [];
      this.chartData4 = [];
      this.clearAllIconStyles();
      const activeClass = `icon${parentIndex + 1}_on`;
      const activeSpanClass = `icon${parentIndex + 1}_on_span`;
      $(".icon" + (parentIndex + 1)).addClass(activeClass);
      $(".icon" + (parentIndex + 1)).children().addClass(activeSpanClass);
      this.loadnameMapdata();
      this.getmapWorld();
      this.loadbar1()
      this.loadbar2();
      this.loadbar3();
      this.loadbar4();
    },
    clearAllIconStyles() {
      for (let i = 1; i <= 11; i++) {
        $(".icon" + i).removeClass("icon" + i + "_on");
        $(".icon" + i).children().removeClass("icon" + i + "_on_span");
      }
    },

    handleIconClick(index, item) {
      this.barindicatorname = item.Name
      this.indicatorid = item.IndicatorId
      this.bardata3 = [];
      this.bardata4 = [];
      this.chartData3 = [];
      this.chartData4 = [];
      if (item.IndicatorId == 44 && item.children && item.children.length > 0) {
        const firstChild = item.children[0];
        this.handleChildClick({
          child: firstChild,
          parentIndex: index,
          parentItem: item,
        });
        return;
      }
      if (item.IndicatorId == 44) {
        this.pageStateMain = true;
        return;
      } else {
        this.pageStateMain = false;
      }
      const methodName = `icon${index + 1}`;
      if (this[methodName]) {
        this[methodName]();
      } else {
        console.warn(`Method ${methodName} not found!`);
      }
      this.getSubIndicators(item.IndicatorId)
      this.getOtherChartsData(item.IndicatorId)
      this.getOtherChartsData2(item.IndicatorId, 0)
      this.getOtherChartsData2(item.IndicatorId, 1)
      this.indicatorname2 = item.IndicatorId
    },
    async getSubIndicators(indicatorId) {
      const data = await api.get("/doingBusiness2026Controller/getAllTopScore2", { indicatorId });
      this.chartData1 = data.data || [];
      this.chart1_img = this.chartData1.length === 0;
    },

    async getOtherChartsData(indicatorId) {
      const params = {
        indicatorId,
        timeid: this.selectyear.length > 4 ? this.selectyear.slice(0, 4) : this.selectyear,
        flagNum: 1,
        dataTypeFlag: true
      };
      const data = await api.get("/doingBusiness2026Controller/getTwentyInfo2", params);
      if (data.data) {
        this.chartData2 = [data.data];
        this.chart2_img = false;
      } else {
        this.chartData2 = [];
        this.chart2_img = true;
      }
    },

    async getOtherChartsData2(indicatorId, type) {
      const params = {
        indicatorId,
        timeid: this.selectyear.length > 4 ? this.selectyear.slice(0, 4) : this.selectyear,
        flagNum: type,
        dataTypeFlag: false
      };
      const data = await api.get("/doingBusiness2026Controller/getTwentyInfo2", params);
      if (type == 0) {
        if (data.data) {
          this.chartData3 = [data.data];
          this.chart3_img = false;
        } else {
          this.chartData3 = [];
          this.chart3_img = true;
        }
      } else {
        if (data.data) {
          this.chartData4 = [data.data];
          this.chart4_img = false;
        } else {
          this.chartData4 = [];
          this.chart4_img = true;
        }
      }
    },
    getFlagPath(name) {
      try {
        return "image://" + require(`@/assets/imgs/flag/${name}.png`)
      } catch (err) {
        return "image://" + require("@/assets/imgs/flag/default.png")
      }
    },
    async loadselectdata() {
      const { code, data } = await api.get(
        "/doingBusiness2026Controller/getTimesAndCountrys",
        {}
      );
      if (code === 0) {
        this.years = data.times;
        this.yearsvalue = data.times[0].name + "";
        this.selectyear = data.times[0].name + "";
      }
    },
    yearsInput(value) {
      this.selectyear = value;
      this.chartData1 = [];
      this.chartData2 = [];
      this.chartData3 = [];
      this.chartData4 = [];
      this.bardata1 = [];
      this.bardata2 = [];
      this.bardata3 = [];
      this.bardata4 = [];
      if (!this.pageStateMain) {
        this.chart1_img = true;
        this.chart2_img = true;
        this.chart3_img = true;
        this.chart4_img = true;
      } else {
        this.chart1_chart = true; this.chart1_img = false;
        this.chart2_chart = true; this.chart2_img = false;
        this.chart3_chart = true; this.chart3_img = false;
        this.chart4_chart = true; this.chart4_img = false;
      }
      this.getmapWorld();
      if (this.pageStateMain) {
        this.loadbar1();
        this.loadbar2();
        this.loadbar3();
        this.loadbar4();
      } else {
        this.getSubIndicators(this.indicatorname2);
        this.getOtherChartsData(this.indicatorname2);
        this.getOtherChartsData2(this.indicatorname2, 0);
        this.getOtherChartsData2(this.indicatorname2, 1);
      }
    },
    async loadnameMapdata() {
      const { code, data } = await api.get(
        "/HomePageController/getCountryMap",
        {}
      );
      if (code === 0) {
        this.nameMap = data;
      }
    },
    async getmapWorld(indicatorId) {
      const id = indicatorId || this.indicatorid;
      const { code, data } = await api.get(
        "/doingBusiness2026Controller/getHomePageMapInfo",
        {
          indicatorId: id,
          timeId: this.selectyear.length > 4 ? this.selectyear.slice(0, 4) : this.selectyear,
          stateIds: -1
        }
      );
      if (code === 0) {
        if (data.length > 0) {
          this.min = data[0].min;
          this.max = data[0].max;
          this.worldData = data[0].data;
        } else {
          this.min = 0;
          this.max = 0;
          this.worldData = [];
        }
      }
      if (this.chartMap) {
        this.chartMap.dispose();
        this.chartMap = null;
      }
      this.$nextTick(() => {
        const dom = document.getElementById("myEchart");
        if (!dom) return;
        this.chartMap = echarts.init(dom);
        initCharts(this.chartMap, this.worldData, this.nameMap, this.min, this.max);
        const resizeHandler = () => this.chartMap && this.chartMap.resize();
        window.removeEventListener("resize", resizeHandler);
        window.addEventListener("resize", resizeHandler);
      });
    },
    chart1replay() {
      this.loadbar1();
    },
    async loadbar1() {
      const { code, data } = await api.get(
        "/doingBusiness2026Controller/getAllTopScore",
        { indicatorId: this.indicatorid }
      );
      if (code === 0) {
        this.bardata1 = data.reverse();
        if (this.chart1) {
          this.chart1.dispose();
          this.chart1 = null;
        }
        this.$nextTick(() => {
          if (!this.$refs.chart1) {
            console.warn('chart1 ref not found');
            return;
          }
          this.chart1 = echarts.init(this.$refs.chart1);
          var tData1 = [];
          if (this.bardata1 != undefined) {
            tData1 = this.makedata_bar1(tData1, this.bardata1);
          }
          barscroll(this.chart1, tData1, 1, true, false, false, $("#chart1div"));
        });
      }
    },
    async loadbar2() {
      const { code, data } = await api.get(
        "/doingBusiness2026Controller/getTwentyInfo",
        {
          indicatorId: this.indicatorid,
          timeid: this.selectyear.length > 4 ? this.selectyear.slice(0, 4) : this.selectyear,
          dataTypeFlag: true
        }
      );
      if (code === 0) {
        if (data.data.length > 0) {
          this.chart2_chart = true;
          this.chart2_img = false;
          this.bardata2 = data;
          if (this.chart2) {
            this.chart2.dispose();
            this.chart2 = null;
          }
          this.$nextTick(() => {
            if (!this.$refs.chart2) return;
            this.chart2 = echarts.init(this.$refs.chart2);
            var tData2 = [];
            if (this.bardata2 != undefined) {
              tData2 = this.makedata(tData2, this.bardata2);
            }
            barscroll(this.chart2, tData2, 2, false, false);
          });
        } else {
          this.chart2_chart = false;
          this.chart2_img = true;
        }
      }
    },
    async loadbar3() {
      const { code, data } = await api.get(
        "/doingBusiness2026Controller/getTwentyInfo",
        {
          indicatorId: this.indicatorid,
          timeid: this.selectyear.length > 4 ? this.selectyear.slice(0, 4) : this.selectyear,
          flagNum: 0,
          dataTypeFlag: false
        }
      );
      if (code === 0) {
        if (data.data.length > 0) {
          this.chart3_chart = true;
          this.chart3_img = false;
          this.bardata3 = data;
          if (this.chart3) {
            this.chart3.dispose();
            this.chart3 = null;
          }
          this.$nextTick(() => {
            if (!this.$refs.chart3) return;
            this.chart3 = echarts.init(this.$refs.chart3);
            var tData3 = [];
            if (this.bardata3 != undefined) {
              tData3 = this.makedata(tData3, this.bardata3);
            }
            barscroll(this.chart3, tData3, 3, false, true, false);
          });
        } else {
          this.chart3_chart = false;
          this.chart3_img = true;
        }
      }
    },
    async loadbar4() {
      const { code, data } = await api.get(
        "/doingBusiness2026Controller/getTwentyInfo",
        {
          indicatorId: this.indicatorid,
          timeid: this.selectyear.length > 4 ? this.selectyear.slice(0, 4) : this.selectyear,
          flagNum: 1,
          dataTypeFlag: false
        }
      );
      if (code === 0) {
        if (data.data.length > 0) {
          this.chart4_chart = true;
          this.chart4_img = false;
          this.bardata4 = data;
          if (this.chart4) {
            this.chart4.dispose();
            this.chart4 = null;
          }
          this.$nextTick(() => {
            if (!this.$refs.chart4) return;
            this.chart4 = echarts.init(this.$refs.chart4);
            var tData4 = [];
            if (this.bardata4 != undefined) {
              tData4 = this.makedata(tData4, this.bardata4);
            }
            barscroll(this.chart4, tData4, 4, false, true, true);
          });
        } else {
          this.chart4_chart = false;
          this.chart4_img = true;
        }
      }
    },
    makedata_bar1(tdata, bardata) {
      for (let i = 0; i < bardata.length; i++) {
        tdata.push({
          category: bardata[i].category,
          data: []
        });
        for (let j = 0; j < bardata[i].data.length; j++) {
          tdata[i].data.push({
            name: bardata[i].data[j].name,
            value: bardata[i].data[j].value
          });
        }
      }
      return tdata;
    },
    makedata(tdata, bardata) {
      tdata.push({
        category: bardata.category,
        data: []
      });
      for (let i = 0; i < bardata.data.length; i++) {
        tdata[0].data.push({
          name: bardata.data[i].name,
          value: bardata.data[i].value
        });
      }
      return tdata;
    },
    icon1() {
      this.indicatorid = 1;
      this.indicatorname = "总体";
      $(".icon1").addClass("icon1_on");
      $(".icon1").children().addClass("icon1_on_span");
      this.icon0(1);
    },
    icon2() {
      this.indicatorid = 2;
      this.indicatorname = "开办企业";
      $(".icon2").addClass("icon2_on");
      $(".icon2").children().addClass("icon2_on_span");
      this.icon0(2);
    },
    icon3() {
      this.indicatorid = 3;
      this.indicatorname = "办理施工许可证";
      $(".icon3").addClass("icon3_on");
      $(".icon3").children().addClass("icon3_on_span");
      this.icon0(3);
    },
    icon4() {
      this.indicatorid = 4;
      this.indicatorname = "获得电力";
      $(".icon4").addClass("icon4_on");
      $(".icon4").children().addClass("icon4_on_span");
      this.icon0(4);
    },
    icon5() {
      this.indicatorid = 5;
      this.indicatorname = "登记财产";
      $(".icon5").addClass("icon5_on");
      $(".icon5").children().addClass("icon5_on_span");
      this.icon0(5);
    },
    icon6() {
      this.indicatorid = 6;
      this.indicatorname = "获得信贷";
      $(".icon6").addClass("icon6_on");
      $(".icon6").children().addClass("icon6_on_span");
      this.icon0(6);
    },
    icon7() {
      this.indicatorid = 7;
      this.indicatorname = "保护少数投资者";
      $(".icon7").addClass("icon7_on");
      $(".icon7").children().addClass("icon7_on_span");
      this.icon0(7);
    },
    icon8() {
      this.indicatorid = 8;
      this.indicatorname = "纳税";
      $(".icon8").addClass("icon8_on");
      $(".icon8").children().addClass("icon8_on_span");
      this.icon0(8);
    },
    icon9() {
      this.indicatorid = 9;
      this.indicatorname = "跨境贸易";
      $(".icon9").addClass("icon9_on");
      $(".icon9").children().addClass("icon9_on_span");
      this.icon0(9);
    },
    icon10() {
      this.indicatorid = 10;
      this.indicatorname = "执行合同";
      $(".icon10").addClass("icon10_on");
      $(".icon10").children().addClass("icon10_on_span");
      this.icon0(10);
    },
    icon11() {
      this.indicatorid = 11;
      this.indicatorname = "办理破产";
      $(".icon11").addClass("icon11_on");
      $(".icon11").children().addClass("icon11_on_span");
      this.icon0(11);
    },
    icon0(num) {
      for (let i = 1; i <= 11; i++) {
        if (num != i) {
          $(".icon" + i).removeClass("icon" + i + "_on");
          $(".icon" + i).children().removeClass("icon" + i + "_on_span");
        }
      }
      this.getmapWorld();
      this.loadbar1();
      this.loadbar2();
      this.loadbar3();
      this.loadbar4();
    },
    numberToChinese(num) {
      const arr = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
      return arr[num] || num;
    }
  },

  watch: {
    $route: function () { },
  }
};
</script>

<style lang='less' scoped>
.searchBar {
  position: fixed;
  background-color: #edf4f8;
  top: 0;
  width: 99.6%;
  padding-right: 2px !important;
  z-index: 999999;
}

.screenbox {
  height: 50px;
  box-sizing: border-box;

  .screen {
    box-sizing: border-box;
    padding: 5px 0 5px 5px;

    .w10 {
      width: 10%;
      padding: 0 5px;
      position: relative;

      .wrap {
        height: 34px;
        border: 0;
        position: relative;
      }
    }

    .icons {
      width: 90%;
      position: relative;
      background: #fff;
      border: 1px solid #d7dfe3;
      height: 34px;
      line-height: 34px;

      ul {
        width: 100%;

        li {
          width: 9%;

          a {
            float: left;
            display: block;
            color: #394248;
            border-right: 1px solid #d7dfe3;
            font-size: 14px;
            height: 34px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            padding-right: 10px;
          }

          .icon {
            height: 34px;
            padding-left: 40px;
            position: relative;
            text-align: center;
          }
        }
      }
    }
  }
}

.mapbox {
  padding: 5px 10px;
  box-sizing: border-box;
}

.w50 {
  width: 50%;
  padding: 0 5px;
  position: relative;
}

.card_title {
  background: url(../../../assets/imgs/titlebj.png) repeat-x top;
  height: 45px;
  line-height: 45px;
  border-bottom: 1px solid #d7dfe3;
  border-left: 1px solid #d7dfe3;
  margin-left: -1px;
}

.card_title h1 {
  text-align: center;
  line-height: 45px;
  font-weight: 600;
  font-size: 0.95vw;
  font-size: 15px;
}

.full_box {
  position: absolute;
  right: 20px;
  top: 10px;
}

.fl11 {
  height: 34px;
  line-height: 34px;
}

.fl11 ul {
  width: 100%;
}

.fl11 ul li a {
  float: left;
  display: block;
  color: #394248;
  border-right: 1px solid #d7dfe3;
  font-size: 15px;
  height: 34px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding-right: 10px;
}

.icon1 {
  background: url(../../../assets/imgs/icon1_ys.png) no-repeat 0 7px;
  height: 24px;
  padding-left: 40px;
}

.icon1:hover {
  background: url(../../../assets/imgs/icon1_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
  color: #f6231b;
}

.icon1_on {
  background: url(../../../assets/imgs/icon1_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon1:hover span {
  color: #f6231b;
  font-weight: 700;
}

.icon1_on_span {
  color: #f6231b;
  font-weight: 700;
}

.icon2 {
  background: url(../../../assets/imgs/icon2_ys.png) no-repeat 0 7px;
  height: 24px;
  padding-left: 40px;
}

.icon2:hover {
  background: url(../../../assets/imgs/icon2_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon2_on {
  background: url(../../../assets/imgs/icon2_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon2:hover span {
  color: #3bd5a1;
  font-weight: 700;
}

.icon2_on_span {
  color: #3bd5a1;
  font-weight: 700;
}

.icon3 {
  background: url(../../../assets/imgs/icon3_ys.png) no-repeat 0 7px;
  height: 24px;
  padding-left: 40px;
}

.icon3:hover {
  background: url(../../../assets/imgs/icon3_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon3_on {
  background: url(../../../assets/imgs/icon3_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon3:hover span {
  color: #9954ac;
  font-weight: 700;
}

.icon3_on_span {
  color: #9954ac;
  font-weight: 700;
}

.icon4 {
  background: url(../../../assets/imgs/icon4_ys.png) no-repeat 0 7px;
  height: 24px;
  padding-left: 40px;
}

.icon4:hover {
  background: url(../../../assets/imgs/icon4_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon4_on {
  background: url(../../../assets/imgs/icon4_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon4:hover span {
  color: #2bcaf4;
  font-weight: 700;
}

.icon4_on_span {
  color: #2bcaf4;
  font-weight: 700;
}

.icon5 {
  background: url(../../../assets/imgs/icon5_ys.png) no-repeat 0 7px;
  height: 24px;
  padding-left: 40px;
}

.icon5:hover {
  background: url(../../../assets/imgs/icon5_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon5_on {
  background: url(../../../assets/imgs/icon5_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon5:hover span {
  color: #fd924b;
  font-weight: 700;
}

.icon5_on_span {
  color: #fd924b;
  font-weight: 700;
}

.icon6 {
  background: url(../../../assets/imgs/icon6_ys.png) no-repeat 0 7px;
  height: 24px;
  padding-left: 40px;
}

.icon6:hover {
  background: url(../../../assets/imgs/icon6_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon6_on {
  background: url(../../../assets/imgs/icon6_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon6:hover span {
  color: #6a75f5;
  font-weight: 700;
}

.icon6_on_span {
  color: #6a75f5;
  font-weight: 700;
}

.icon7 {
  background: url(../../../assets/imgs/icon7_ys.png) no-repeat 0 7px;
  height: 24px;
  padding-left: 40px;
}

.icon7:hover {
  background: url(../../../assets/imgs/icon7_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon7_on {
  background: url(../../../assets/imgs/icon7_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon7:hover span {
  color: #5cd46c;
  font-weight: 700;
}

.icon7_on_span {
  color: #5cd46c;
  font-weight: 700;
}

.icon8 {
  background: url(../../../assets/imgs/icon8_ys.png) no-repeat 0 7px;
  height: 24px;
  padding-left: 40px;
}

.icon8:hover {
  background: url(../../../assets/imgs/icon8_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon8_on {
  background: url(../../../assets/imgs/icon8_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon8:hover span {
  color: #c79706;
  font-weight: 700;
}

.icon8_on_span {
  color: #c79706;
  font-weight: 700;
}

.icon9 {
  background: url(../../../assets/imgs/icon9_ys.png) no-repeat 0 7px;
  height: 24px;
  padding-left: 40px;
}

.icon9:hover {
  background: url(../../../assets/imgs/icon9_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon9_on {
  background: url(../../../assets/imgs/icon9_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon9:hover span {
  color: #71b5fe;
  font-weight: 700;
}

.icon9_on_span {
  color: #71b5fe;
  font-weight: 700;
}

.icon10 {
  background: url(../../../assets/imgs/icon10_ys.png) no-repeat 0 7px;
  height: 24px;
  padding-left: 40px;
}

.icon10:hover {
  background: url(../../../assets/imgs/icon10_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon10_on {
  background: url(../../../assets/imgs/icon10_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon10:hover span {
  color: #fd91a3;
  font-weight: 700;
}

.icon10_on_span {
  color: #fd91a3;
  font-weight: 700;
}

.icon11 {
  background: url(../../../assets/imgs/icon11_ys.png) no-repeat 0 7px;
  height: 24px;
  padding-left: 40px;
}

.icon11:hover {
  background: url(../../../assets/imgs/icon11_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon11_on {
  background: url(../../../assets/imgs/icon11_h.png) no-repeat 0 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon11:hover span {
  color: #2bcaf4;
  font-weight: 700;
}

.icon11_on_span {
  color: #2bcaf4;
  font-weight: 700;
}

.fl11 ul li a:nth-child(11) {
  border-right: none;
}

.replay {
  background: #f4f8fb;
  border: 1px solid #d4d9dc;
  border-radius: 100px;
  padding: 5px 15px;
  color: #232e36;
  font-size: 14px;
}

.w9 {
  width: 9.09%;
  padding: 0 5px;
  position: relative;
  padding-left: 40px;
}

.w11-09 {
  width: 10.89%;
  padding: 0 5px;
  position: relative;
  padding-left: 40px;
}

.w7-09 {
  width: 7.29%;
  padding: 0 5px;
  position: relative;
  padding-left: 40px;
}

.year {
  padding: 25px;
}

.year img {
  float: left;
}

.year h2 {
  float: left;
  font-size: 18x;
  line-height: 25px;
  padding-left: 10px;
}

.col-lg-6 {
  float: left;
  border-left: 1px solid #d7dfe3;
  border-top: 1px solid #d7dfe3;
  padding: 20px 20px 30px 20px;
}

.review {
  border: 1px solid transparent;
  border-radius: 5px;
  color: #777;
  display: flex;
  font-size: 12px;
  align-items: center;
  margin: 0px 10px;
  width: 57.5%;
  margin-top: 9px;
}

.progress {
  background-color: rgba(100, 100, 100, 0.2);
  border-radius: 100px;
  position: relative;
  margin: 0 5px;
  height: 20px;
  width: 90%;
}

.progress-done1 {
  background: linear-gradient(to left, rgb(103, 194, 58), rgb(166, 213, 83));
  border-radius: 100px;
  height: 20px;
  transition: width 1s ease 0.3s;
}

.progress-done2 {
  background: linear-gradient(to left, rgb(242, 97, 90), rgb(255, 148, 114));
  border-radius: 100px;
  height: 20px;
  transition: width 1s ease 0.3s;
}

.percent {
  color: #333;
  white-space: nowrap;
}

.characteristics ul li {
  float: left;
  padding-left: 5px;
  padding-right: 20px;
  padding-top: 10px;
}

.characteristics ul li span {
  font-weight: bold;
}

.col-lg-6 h2 {
  font-size: 15px;
  font-weight: bold;
  margin-top: 9px;
  margin-left: 20px;
}

.percent1 {
  position: absolute;
  left: 0px;
  display: inline-block;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
}

.menu_box {
  width: 30%;
}

.menu_box_ul {
  background: #f4f7fa;
  border: 1px solid #d4dfea;
  border-radius: 20px;
  padding: 15px;
  padding-left: 0;
  margin: 15px;
  position: relative;
  z-index: 1000;
}

.menu_box_ul li {
  line-height: 35px;
}

.menu_box_ul li a {
  display: block;
  height: 34px;
  font-size: 13px;
  line-height: 34px;
  color: #30363c;
}

.txbox {
  margin-left: 200px;
  position: absolute;
}

.ysbg ul {
  width: 50%;
  float: left;
  padding: 25px;
}

.ysbg ul li {
  line-height: 35px;
}

.ysbg ul li a {
  color: #333;
  width: 80%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.ysbg ul li span {
  color: #666;
}

.icon_lx {
  padding-right: 5px;
}

.ld_jjt {
  background: #f4f7fa !important;
  border: 1px solid#d4dfea;
  border-radius: 100px;
}

.black {
  color: #30363c !important;
}

.k-icon2 {
  position: relative;
  display: inline-block;
  overflow: hidden;
  width: 1em;
  height: 1em;
  text-align: center;
  vertical-align: middle;
  background: url(../../../assets/imgs/drop-down2.png) no-repeat center;
  font: 16px/1 WebComponentsIcons;
  font-variant-caps: normal;
  font-weight: normal;
  font-family: WebComponentsIcons;
  font-variant-alternates: normal;
  font-variant-east-asian: normal;
  font-variant-ligatures: normal;
  font-variant-numeric: normal;
  font-variant-position: normal;
  speak: none;
  font-variant: normal;
  text-transform: none;
  text-indent: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: inherit;
}

.screenbox {
  .screen {
    .icons {
      ul {
        li {
          a {
            display: block;
            color: #394248;
            border-right: 1px solid #d7dfe3;
            font-size: 15px;
            height: 34px;
            line-height: 34px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            padding-left: 20px;
            text-align: center;
          }
        }
      }
    }
  }
}

::v-deep .el-dropdown {
  display: block;
  width: 100%;
  height: 100%;
  padding-left: 8px;

  .el-dropdown-selfdefine {
    display: block !important;
    width: 100%;
    height: 34px;
    padding: 0;
    line-height: 34px;
    float: none !important;
  }
}

.icons ul li {
  position: relative;
  float: left;
  height: 34px;

  a {
    display: block;
    width: 100%;
    height: 34px;
    line-height: 34px;
    float: none;
    text-align: center;
  }
}

::v-deep .el-input--suffix {
  background-color: #1583cc !important;
}

.Z-active {
  background-color: #edf5fc;
  color: #6dabe4;
}
</style>